import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'tipoImpuesto'
})
export class TipoImpuestoPipe implements PipeTransform {

  transform(value: string): string {
    switch(value) {
      case '001':
        value = value+' - ISR';
      break
      case '002':
        value = value+' - IVA';
      break
      case '003':
        value = value+' - IEPS';
      break
    }

    return value;
  }

}
